import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosApi';

export const loginAdmin = createAsyncThunk(
    'admin/login',
    async ({ username, password }, { rejectWithValue }) => {
        try {
            const response = await axios.post('/admin/login', { username, password });
            const token = response.data.token;

            return { token };
        } catch (e) {
            return rejectWithValue(e.response?.data?.error || 'Login failed');
        }
    }
);

export const logoutAdmin = createAsyncThunk(
    'admin/logout',
    async (_, { rejectWithValue }) => {
        try {
            // Authorization добавляет axiosApi request interceptor из localStorage['admin'].
            await axios.post('/admin/logout');
            // admin state и localStorage['admin'] чистятся в logoutAdmin.fulfilled
            // (reducer) + localStorageMiddleware.
        } catch (e) {
            // 401 обрабатывает глобальный authEvents flow (clearAdmin + очистка 'admin').
            return rejectWithValue(e.response?.data?.error || 'Logout failed');
        }
    }
);
